export default {
  en: {
    currencyFrom: 'Currency From',
    editConversionInfo: 'The conversion is always to {{currency}}',
    calculator: 'Calculator',
    whoops: 'Whoops!',
    noContentMessage: "Sorry, there aren't any changes that pertain to you",
    gotIt: 'Got It!',
    skip: 'Skip',
    previous: 'Previous',
    createNote: 'Create Release Note',
    editNote: 'Edit Release Note',
    releaseName: 'Release Name',
    releaseDate: 'Release Date',
    changeName: 'Change Name',
    label: 'Label',
    lReleaseNote: 'release note',
    noReleaseNote: 'no release note',
    hasPermission: 'Has Permission',
    numberFormat: 'Number Format',
    releaseNotes: 'Release Notes',
  },
  es: {
    currencyFrom: 'Moneda de',
    editConversionInfo: 'La conversión es siempre a {{currency}}',
    calculator: 'Calculadora',
    whoops: '¡Ups!',
    noContentMessage: 'Lo sentimos, no hay cambios que le conciernan.',
    gotIt: '¡Ya lo tengo!',
    skip: 'Saltar',
    previous: 'Anterior',
    createNote: 'Crear Nota de Publicación',
    editNote: 'Editar Nota de Publicación',
    releaseName: 'Nombre de la Publicación',
    releaseDate: 'Fecha de Publicación',
    changeName: 'Cambiar el Nombre',
    label: 'Label',
    lReleaseNote: 'Nota de publicación',
    noReleaseNote: 'Sin nota de lanzamiento',
    hasPermission: 'Tiene Permiso',
    numberFormat: 'Formato numérico',
  },
  tr: {
    currencyFrom: 'Para Biriminden',
    editConversionInfo: "Para dönüṣümü her zaman {{currency}} 'a",
    calculator: 'Hesap makinesi',
    whoops: 'Ops!',
    noContentMessage: 'Maalesef, konuyla ilgili herhangi bir değişiklik yok',
    gotIt: 'Tamam!',
    skip: 'Atla',
    previous: 'Önceki',
    createNote: 'Sürüm Notu Oluştur',
    editNote: 'Sürüm Notunu Düzenle',
    releaseName: 'Sürüm Adı',
    releaseDate: 'Sürüm Tarihi',
    changeName: 'İsmi Değiştir',
    label: 'Etiket',
    lReleaseNote: 'sürüm notu',
    noReleaseNote: 'sürüm notu yok',
    hasPermission: 'İzin Var',
  },
  ru: {
    currencyFrom: 'Валюта из',
    editConversionInfo: 'Конвертация всегда проводится в {{currency}}',
    calculator: 'Калькулятор',
    whoops: 'Ой!',
    noContentMessage: 'Извините, никаких изменений, касающихся вас, не произошло.',
    gotIt: 'Понятно',
    skip: 'Пропустить',
    previous: 'Предыдущий',
    createNote: 'Создать примечание к релизу',
    editNote: 'Редактировать примечание к релизу',
    releaseName: 'Название релиза',
    releaseDate: 'Дата релиза',
    changeName: 'Поменять названуе',
    label: 'Лейбл',
    lReleaseNote: 'примечание к релизу',
    noReleaseNote: 'примечание к релизу отсутствует',
    hasPermission: 'Имеет разрешение',
    numberFormat: 'Формат чисел\n',
  },
  pt: {
    currencyFrom: 'Moeda de',
    editConversionInfo: 'A conversão é sempre para {{currency}}',
    calculator: 'Calculadora',
    whoops: 'Ops!',
    noContentMessage: 'Desculpe, não há alterações relacionadas a você',
    gotIt: 'Entendi!',
    skip: 'Pular',
    previous: 'Anterior',
    createNote: 'Criar nota de lançamento',
    editNote: 'Edita nota de lançamento',
    releaseName: 'Nome do lançamento',
    releaseDate: 'Data de lançamento',
    changeName: 'Alterar o nome',
    label: 'Etiqueta',
    lReleaseNote: 'nota de lançamento',
    noReleaseNote: 'sem nota de lançamento',
    hasPermission: 'Tem permissão',
    numberFormat: 'Formato numérico',
  },
  zh: {
    currencyFrom: '货币来源',
    editConversionInfo: '货币始终兑换为 {{currency}}',
    calculator: '计算器',
    whoops: '哎呀！',
    noContentMessage: '抱歉，没有任何与您相关的更改',
    gotIt: '明白了！',
    skip: '跳过',
    previous: '先前',
    createNote: '创建发布说明',
    editNote: '编辑发布说明',
    releaseName: '发布名称',
    releaseDate: '发布日期',
    changeName: '更改名称',
    label: '标签',
    lReleaseNote: '发布说明',
    noReleaseNote: '无发布说明',
    hasPermission: '有权限',
    numberFormat: '数字格式',
  },
  ro: {
    currencyFrom: 'Monedă din ',
    editConversionInfo: 'Conversia valutară va fi întotdeauna efectuată în {{currency}}',
    calculator: 'Calculator',
    releaseNotes: 'Note de lansare',
    whoops: 'Ups!',
    noContentMessage: 'Ne pare rău, nu există modificări relevante pentru tine',
    gotIt: 'Am înțeles',
    skip: 'Omitere',
    previous: 'Anterior',
    createNote: 'Crearea notă de lansare',
    editNote: 'Editare notă de lansare',
    releaseName: 'Nume lansare',
    releaseDate: 'Data lansării',
    changeName: 'Modificare nume',
    label: 'Etichetă',
    lReleaseNote: 'notă de lansare',
    noReleaseNote: 'fără notă de lansare',
    hasPermission: 'Are permisiune',
    numberFormat: 'Format număr',
  },
  bg: {},
  el: {
    currencyFrom: 'Νόμισμα από',
    editConversionInfo: 'Η μετατροπή είναι πάντα προς {{currency}}',
    calculator: 'Εργαλείο υπολογισμού',
    releaseNotes: 'Σημειώσεις έκδοσης',
    whoops: 'Ωχ!',
    noContentMessage: 'Δυστυχώς, δεν υπάρχουν αλλαγές που να σας αφορούν',
    gotIt: 'Το κατάλαβα!',
    skip: 'Παράλειψη',
    previous: 'Προηγούμενο',
    createNote: 'Δημιουργία σημείωσης έκδοσης',
    editNote: 'Επεξεργασία σημείωσης έκδοσης',
    releaseName: 'Όνομα έκδοσης',
    releaseDate: 'Ημερομηνία έκδοσης',
    changeName: 'Αλλαγή ονόματος',
    label: 'Επιγραφή',
    lReleaseNote: 'σημείωση έκδοσης',
    noReleaseNote: 'δεν υπάρχει σημείωση έκδοσης',
    hasPermission: 'Έχει άδεια',
    numberFormat: 'Μορφή αριθμών',
  },
};
